<template>
	<!-- @deprecated; THIS COMPONENT IS DEPRECATED -->
	<div
		:class="`formulate-input-element formulate-input-element--${context.type}`"
		:data-type="context.type">
		<b-row>
			<b-col lg="6">
				<FormulateInput v-model="sport_activity"
					type="select"
					name="sport_activity"
					:label="label"
					outer-class="form-group"
					input-class="custom-select"
					placeholder="-- Select --"
					validation="required"
					validation-name="Activity"
					:options="sports" />
			</b-col>
			<b-col lg="6">
				<FormulateInput v-model="sport_type"
					type="select"
					name="sport_type"
					label="Type"
					outer-class="form-group"
					input-class="custom-select"
					placeholder="-- Select a Type --"
					validation="required"
					validation-name="Type"
					:options="{
						'team': 'Team',
						'league': 'League and/or Club',
						'association': 'Association',
						'tournament': 'Event and/or Tournament',
						'camp': 'Camp/Clinic',
						'other': 'Other'
					}" />
			</b-col>
		</b-row>

		<template v-if="sport_type && (sport_type === 'camp' || sport_type === 'tournament')">
			<b-row class="mb-4">
				<b-col>
					<FormulateInput
						v-model="tournament_address"
						type="full_address"
						name="tournament_address"
						label="Tournament Address" />
				</b-col>
			</b-row>
			<b-row class="mb-4">
				<b-col cols="4">
					<FormulateInput
						v-model="tournament_date"
						type="vcal"
						name="tournament_date"
						label="Tournament Date" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<FormulateInput
						v-model="concussion_management_policy"
						type="yes_no_explain"
						label="Do you have a written concussion management policy that is compliant with current state legislation?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Concussion management policy confirmation" />
					<FormulateInput
						v-model="concussion_play_removal"
						type="yes_no_explain"
						label="Does your policy require that any participant suspected of sustaining a head injury be removed from play immediately?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Removal confirmation" />
					<FormulateInput
						v-model="concussion_medical_check"
						type="yes_no_explain"
						label="Does your policy require that any participant sustaining a head injury to be cleared by a licensed healthcare provider before the player is allowed to return to practices?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Medically cleared confirmation" />
					<FormulateInput
						v-model="concussion_policy_distribution"
						type="yes_no_explain"
						label="Do you distribute the written policy to coaches, parents and players and require parents’ written acknowledgment that they have received and reviewed?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Policy distribution confirmation" />
					<FormulateInput
						v-model="concussion_recognition"
						type="yes_no_explain"
						label="Do you require your coaches to undergo formal training (at minimum) for concussion recognition?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Recognition confirmation" />
					<FormulateInput
						v-model="subcontractors_liability_coverage"
						type="yes_no_explain"
						label="Do you require all vendors/exhibitor and subcontractors to provide you with valid proof of liability insurance, showing You listed as additional insured?"
						help="Minimum $1,000,000 occurrence / $2,000,000 aggregate limits"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Vendors/exhibitor and subcontractors liability insurance confirmation" />
					<p v-if="subcontractors_liability_coverage === 'no'" class="mb-4 border-left pl-4">
						<em>
							Please note, there is a warranty in your policy that states that you are required to follow this practice, or coverage will not apply to any claim arising out of any subcontractor’s, vendor’s or exhibitors liability.
						</em>
					</p>
					<FormulateInput
						v-if="sport_type === 'tournament'"
						v-model="guests_carry_valid_liability"
						type="yes_no_explain"
						label="Do you require all guests and visiting teams to carry their own valid liability insurance, listing your organization as an additional insured?"
						outer-class="form-group"
						input-class="form-control"
						validation="required"
						validation-name="Guest liability coverage confirmation" />
				</b-col>
			</b-row>
		</template>

		<b-row>
			<b-col>
				<FormulateInput
					v-model="sport_details"
					type="textarea"
					name="sport_details"
					:debounce="1000"
					outer-class="form-group"
					input-class="form-control"
					label="Details (optional)"
					validation="optional" />
			</b-col>
		</b-row>

		<b-row>
			<b-col>
				<FormulateInput v-model="sport_level"
					type="select"
					name="sport_level"
					label="Sport Level"
					outer-class="form-group"
					input-class="custom-select"
					placeholder="-- Select the Sport Level --"
					validation="required"
					validation-name="Sport Level"
					:options="{
						'none': 'None',
						'amateur': 'Amateur',
						'semi-pro': 'Semi-Professional',
						'pro': 'Professional'
					}" />
			</b-col>
			<b-col>
				<FormulateInput v-model="sport_days"
					name="sport_days"
					type="number"
					label="Number of Days"
					placeholder="#"
					outer-class="form-group"
					input-class="form-control"
					validation="required"
					validation-name="Number of playing days" />
			</b-col>
			<b-col v-if="sport_type && (sport_type === 'camp' || sport_type === 'tournament')">
				<FormulateInput v-model="participants_per_day"
					name="participants_per_day"
					type="number"
					label="Max # of Participants Per Day"
					placeholder="#"
					outer-class="form-group"
					input-class="form-control"
					validation="required"
					validation-name="Participants Per Day" />
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<p class="mb-3"><em>...including games, practices and tournaments (for period of coverage)</em></p>
			</b-col>
		</b-row>
		<b-row v-if="version === '0'">
			<b-col lg="4" sm="6">
				<FormulateInput
					v-model="sport_participants_9"
					name="sport_participants_9"
					label="Ages 9 and Younger"
					placeholder="# of participants"
					outer-class="form-group"
					input-class="form-control"
					:validation="participantValidation"
					validation-name="Number of participants under age 9" />
			</b-col>
			<b-col lg="4" sm="6">
				<FormulateInput
					v-model="sport_participants_12"
					name="sport_participants_12"
					label="Ages 10-12"
					placeholder="# of participants"
					outer-class="form-group"
					input-class="form-control"
					:validation="participantValidation"
					validation-name="Number of participants under age 12" />
			</b-col>
			<b-col lg="4" sm="6">
				<FormulateInput
					v-model="sport_participants_13_15"
					name="sport_participants_13_15"
					label="Ages 13-15"
					placeholder="# of participants"
					outer-class="form-group"
					input-class="form-control"
					:validation="participantValidation"
					:debounce="500"
					validation-name="Number of participants between age 13 and 15" />
			</b-col>
			<b-col lg="4" sm="6">
				<FormulateInput
					v-model="sport_participants_16_18"
					name="sport_participants_16_18"
					label="Ages 16-18"
					placeholder="# of participants"
					outer-class="form-group"
					input-class="form-control"
					:validation="participantValidation"
					validation-name="Number of participants between age 16 and 18" />
			</b-col>
			<b-col lg="4" sm="6">
				<FormulateInput
					v-model="sport_participants_19"
					name="sport_participants_19"
					label="Ages 19 and older"
					placeholder="# of participants"
					outer-class="form-group"
					input-class="form-control"
					:validation="participantValidation"
					validation-name="Number of participants at least age 19" />
			</b-col>
		</b-row>
		<template v-if="version === '2020-09-14'">
			<b-row>
				<b-col>
					<h5 class="mb-2 mt-1 text-grey">Total number of participants:</h5>
					<b-alert variant="danger" :show="invalidParticipants">
						You may only add up to {{ maxParticipants }} participants per team, you added {{ totalParticipants }} participants but only {{ totalTeams }} team(s).
						Reduce the number of participants or increase the number of teams in order to continue.
					</b-alert>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_10"
						name="sport_participants_10"
						label="Ages 10 and Younger"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						validation-name="Number of participants under age 10" />
				</b-col>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_12"
						name="sport_participants_12"
						label="Ages 12 and Younger"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						validation-name="Number of participants under age 12" />
				</b-col>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_13_16"
						name="sport_participants_13_16"
						label="Ages 13-16"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						:debounce="500"
						validation-name="Number of participants between age 13 and 16" />
				</b-col>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_17_19"
						name="sport_participants_17_19"
						label="Ages 17-19"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						validation-name="Number of participants between age 17 and 19" />
				</b-col>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_21"
						name="sport_participants_21"
						label="Ages 21 and under"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						validation-name="Number of participants under age 21" />
				</b-col>
				<b-col lg="4" sm="6">
					<FormulateInput
						v-model="sport_participants_22"
						name="sport_participants_22"
						label="Ages 22 and over"
						placeholder="# of participants"
						outer-class="form-group"
						input-class="form-control"
						:validation="participantValidation"
						validation-name="Number of participants age 22 and over" />
				</b-col>
				<b-col>
					<FormulateInput
						v-model="sport_number_of_teams"
						name="sport_number_of_teams"
						label="Total Number of Teams"
						placeholder="#"
						outer-class="form-group"
						input-class="form-control"
						:validation="[['required'], ['number'], ['min', minimumTeams]]"
						validation-name="Number of Teams" />
				</b-col>
			</b-row>
		</template>
		<div v-if="version === '2022-02-01'" class="mt-3 mb-3">
			<b-table-simple bordered dark hover>
				<b-thead>
					<b-tr>
						<b-th>Group</b-th>
						<b-th style="width: 33%;">Number of Participants</b-th>
						<b-th style="width: 33%;">Number of Teams</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-if="sport_activity !== 'softball'">
						<b-td><strong>Ages 10 and Under</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_10"
								type="number"
								name="sport_participants_10"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of participants under age 10" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_10"
								type="number"
								name="sport_teams_10"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of teams with participants under age 10" />
						</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>Ages 12 and Under</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_12"
								type="number"
								name="sport_participants_12"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of participants under age 12" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_12"
								type="number"
								name="sport_teams_12"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of teams with participants under age 12" />
						</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>Ages 13-16</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_13_16"
								type="number"
								name="sport_participants_13_16"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of teams with participants between age 13 and 16" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_13_16"
								type="number"
								name="sport_teams_13_16"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of participants between age 13 and 16" />
						</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>Ages 17-19</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_17_19"
								type="number"
								name="sport_participants_17_19"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of participants between age 17 and 19" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_17_19"
								type="number"
								name="sport_teams_17_19"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of teams with participants between age 17 and 19" />
						</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>Ages 21 and Under</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_21"
								type="number"
								name="sport_participants_21"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of participants under age 21" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_21"
								type="number"
								name="sport_teams_21"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of teams with participants under age 21" />
						</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>Ages 22 and Over</strong></b-td>
						<b-td>
							<FormulateInput
								v-model="sport_participants_22"
								type="number"
								name="sport_participants_22"
								placeholder="# of participants"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="participantValidation"
								validation-name="Number of participants age 22 and over" />
						</b-td>
						<b-td>
							<FormulateInput
								v-model="sport_teams_22"
								type="number"
								name="sport_teams_22"
								placeholder="# of teams"
								min="0"
								outer-class="form-group mb-0"
								input-class="form-control"
								:validation="teamsValidation"
								validation-name="Number of teams with participants age 22 and over" />
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
		<b-row v-if="totalTeams <= 0 || totalParticipants <= 0">
			<b-col>
				<b-alert show variant="warning">You must enter at least one participant for each team.</b-alert>
			</b-col>
		</b-row>
		<b-row>
			<b-col lg="6">
				<FormulateInput
					v-model="sport_gross_receipts"
					name="sport_gross_receipts"
					type="icon_input"
					icon="dollar-sign"
					label="Total Gross Receipts"
					placeholder="0.00"
					outer-class="form-group"
					input-class="form-control"
					validation="required"
					validation-name="Total Gross Receipts" />
			</b-col>
		</b-row>
	</div>
</template>
<script>
import {ceil} from 'lodash/math'

export default {
	// DEPRECATED COMPONENT
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			version: '2022-02-01',
			validationMessages: {
				'min': 'You must add at least one activity.'
			},
			label: 'Sport',
			sports: [],
			sport_activity: null,
			sport_type: null,
			sport_details: '',
			sport_level: null,
			sport_days: null,
			participants_per_day: null,

			// version 0
			sport_participants_9: 0,
			sport_participants_12: 0,
			sport_participants_13_15: 0,
			sport_participants_16_18: 0,
			sport_participants_19: 0,

			// added 2020-09-14
			sport_participants_10: 0,
			sport_participants_13_16: 0,
			sport_participants_17_19: 0,
			sport_participants_21: 0,
			sport_participants_22: 0,

			// added 2022-02-01
			sport_teams_10: 0,
			sport_teams_12: 0,
			sport_teams_13_16: 0,
			sport_teams_17_19: 0,
			sport_teams_21: 0,
			sport_teams_22: 0,

			sport_gross_receipts: null,
			sport_number_of_teams: null,

			// camp and tournaments
			tournament_date: null,
			concussion_management_policy: null,
			concussion_play_removal: null,
			concussion_medical_check: null,
			concussion_policy_distribution: null,
			concussion_recognition: null,
			subcontractors_liability_coverage: null,
			guests_carry_valid_liability: null,
			tournament_address: {}
		}
	},
	computed: {
		maxParticipants () {
			if (this.context && this.context.attributes['max_participants'] !== undefined) {
				return this.context.attributes['max_participants']
			}

			return 9999
		},
		invalidParticipants () {
			if (! this.totalTeams) {
				return false
			}

			const maxParticipants = this.totalTeams * this.maxParticipants
			return this.totalParticipants > maxParticipants
		},
		totalParticipants () {
			let totalParticipants = 0

			if (this.context.model.hasOwnProperty('sport_participants_9')) {
				const sport_participants_9 = parseInt(this.context.model['sport_participants_9'])
				if (sport_participants_9) {
					totalParticipants += sport_participants_9
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_10')) {
				const sport_participants_10 = parseInt(this.context.model['sport_participants_10'])
				if (sport_participants_10) {
					totalParticipants += sport_participants_10
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_12')) {
				const sport_participants_12 = parseInt(this.context.model['sport_participants_12'])
				if (sport_participants_12) {
					totalParticipants += sport_participants_12
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_13_15')) {
				const sport_participants_13_15 = parseInt(this.context.model['sport_participants_13_15'])
				if (sport_participants_13_15) {
					totalParticipants += sport_participants_13_15
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_13_16')) {
				const sport_participants_13_16 = parseInt(this.context.model['sport_participants_13_16'])
				if (sport_participants_13_16) {
					totalParticipants += sport_participants_13_16
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_17_19')) {
				const sport_participants_17_19 = parseInt(this.context.model['sport_participants_17_19'])
				if (sport_participants_17_19) {
					totalParticipants += sport_participants_17_19
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_16_18')) {
				const sport_participants_16_18 = parseInt(this.context.model['sport_participants_16_18'])
				if (sport_participants_16_18) {
					totalParticipants += sport_participants_16_18
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_19')) {
				const sport_participants_19 = parseInt(this.context.model['sport_participants_19'])
				if (sport_participants_19) {
					totalParticipants += sport_participants_19
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_21')) {
				const sport_participants_21 = parseInt(this.context.model['sport_participants_21'])
				if (sport_participants_21) {
					totalParticipants += sport_participants_21
				}
			}

			if (this.context.model.hasOwnProperty('sport_participants_22')) {
				const sport_participants_22 = parseInt(this.context.model['sport_participants_22'])
				if (sport_participants_22) {
					totalParticipants += sport_participants_22
				}
			}

			return totalParticipants
		},
		totalTeams () {
			let totalTeams = 0

			const teamFields = [
				'sport_number_of_teams',
				'sport_teams_10',
				'sport_teams_12',
				'sport_teams_13_16',
				'sport_teams_17_19',
				'sport_teams_21',
				'sport_teams_22'
			]

			for (const teamFieldsKey in teamFields) {
				if (!teamFields.hasOwnProperty(teamFieldsKey)) continue
				const fieldName = teamFields[teamFieldsKey]

				if (this.context.model.hasOwnProperty(fieldName) && this.context.model[fieldName]) {
					totalTeams+= parseInt(this.context.model[fieldName])
				}
			}

			return totalTeams
		},
		minimumTeams () {
			if (this.invalidParticipants) {
				return ceil(this.totalParticipants / this.maxParticipants)
			}

			return 1
		},
		participantValidation () {
			let max = this.maxParticipants
			let min = 0
			let teams = this.totalTeams

			if (! this.totalTeams) {
				max = 9999
			} else {
				max = max * teams
			}

			if (this.totalParticipants === 0) {
				min = 1
			}

			return 'required|number|max:' + max + '|min:' + min
		},
		teamsValidation () {
			return this.totalTeams === 0 ? 'required|number|min:1' : 'required|number|min:0'
		}
	},
	watch: {
		sport_activity (newValue) {
			this.$set(this.context.model, 'sport_activity', newValue)

			if (newValue === 'softball') {
				this.$set(this.context.model, 'sport_participants_10', 0)
				this.$set(this.context.model, 'sport_teams_10', 0)
			}
		},
		sport_type (newValue) {
			this.$set(this.context.model, 'sport_type', newValue)
		},
		sport_details (newValue) {
			this.$set(this.context.model, 'sport_details', newValue)
		},
		sport_level (newValue) {
			this.$set(this.context.model, 'sport_level', newValue)
		},
		sport_days (newValue) {
			this.$set(this.context.model, 'sport_days', newValue)
		},
		participants_per_day (newValue) {
			this.$set(this.context.model, 'participants_per_day', newValue)
		},
		sport_participants_9 (newValue) {
			this.$set(this.context.model, 'sport_participants_9', newValue)
		},
		sport_participants_10 (newValue) {
			this.$set(this.context.model, 'sport_participants_10', newValue)
		},
		sport_participants_12 (newValue) {
			this.$set(this.context.model, 'sport_participants_12', newValue)
		},
		sport_participants_13_15 (newValue) {
			this.$set(this.context.model, 'sport_participants_13_15', newValue)
		},
		sport_participants_13_16 (newValue) {
			this.$set(this.context.model, 'sport_participants_13_16', newValue)
		},
		sport_participants_16_18 (newValue) {
			this.$set(this.context.model, 'sport_participants_16_18', newValue)
		},
		sport_participants_17_19 (newValue) {
			this.$set(this.context.model, 'sport_participants_17_19', newValue)
		},
		sport_participants_19 (newValue) {
			this.$set(this.context.model, 'sport_participants_19', newValue)
		},
		sport_participants_21 (newValue) {
			this.$set(this.context.model, 'sport_participants_21', newValue)
		},
		sport_participants_22 (newValue) {
			this.$set(this.context.model, 'sport_participants_22', newValue)
		},
		sport_gross_receipts (newValue) {
			this.$set(this.context.model, 'sport_gross_receipts', newValue)
		},
		sport_number_of_teams (newValue) {
			this.$set(this.context.model, 'sport_number_of_teams', newValue)
		},
		version (newValue) {
			this.$set(this.context.model, 'version', newValue)
		},
		tournament_date (newValue) {
			this.$set(this.context.model, 'tournament_date', newValue)
		},
		concussion_management_policy (newValue) {
			this.$set(this.context.model, 'concussion_management_policy', newValue)
		},
		concussion_play_removal (newValue) {
			this.$set(this.context.model, 'concussion_play_removal', newValue)
		},
		concussion_medical_check (newValue) {
			this.$set(this.context.model, 'concussion_medical_check', newValue)
		},
		concussion_policy_distribution (newValue) {
			this.$set(this.context.model, 'concussion_policy_distribution', newValue)
		},
		concussion_recognition (newValue) {
			this.$set(this.context.model, 'concussion_recognition', newValue)
		},
		subcontractors_liability_coverage (newValue) {
			this.$set(this.context.model, 'subcontractors_liability_coverage', newValue)
		},
		guests_carry_valid_liability (newValue) {
			this.$set(this.context.model, 'guests_carry_valid_liability', newValue)
		},
		tournament_address (newValue) {
			this.$set(this.context.model, 'tournament_address', newValue)
		},
		sport_teams_10 (newValue) {
			this.$set(this.context.model, 'sport_teams_10', newValue)
		},
		sport_teams_12 (newValue) {
			this.$set(this.context.model, 'sport_teams_12', newValue)
		},
		sport_teams_13_16 (newValue) {
			this.$set(this.context.model, 'sport_teams_13_16', newValue)
		},
		sport_teams_17_19 (newValue) {
			this.$set(this.context.model, 'sport_teams_17_19', newValue)
		},
		sport_teams_21 (newValue) {
			this.$set(this.context.model, 'sport_teams_21', newValue)
		},
		sport_teams_22 (newValue) {
			this.$set(this.context.model, 'sport_teams_22', newValue)
		}
	},
	mounted () {
		if (this.context.attributes.hasOwnProperty('sports')) {
			this.sports = this.context.attributes['sports']
		}

		if (typeof this.context.model !== 'object') {
			// eslint-disable-next-line vue/no-mutating-props
			this.context.model = {
				version: this.version,
				sport_activity: null,
				sport_type: null,
				sport_details: null,
				sport_level: null,
				sport_days: null,
				participants_per_day: null,

				// version 0
				sport_participants_9: 0,
				sport_participants_12: 0,
				sport_participants_13_15: 0,
				sport_participants_16_18: 0,
				sport_participants_19: 0,

				// added 2020-09-14
				sport_participants_10: 0,
				sport_participants_13_16: 0,
				sport_participants_17_19: 0,
				sport_participants_21: 0,
				sport_participants_22: 0,

				// added 2022-02-01
				sport_teams_10: 0,
				sport_teams_12: 0,
				sport_teams_13_16: 0,
				sport_teams_17_19: 0,
				sport_teams_21: 0,
				sport_teams_22: 0,

				sport_gross_receipts: null,
				sport_number_of_teams: null,

				tournament_date: null,
				concussion_management_policy: null,
				concussion_play_removal: null,
				concussion_medical_check: null,
				concussion_policy_distribution: null,
				concussion_recognition: null,
				subcontractors_liability_coverage: null,
				guests_carry_valid_liability: null,
				tournament_address: {}
			}
		}

		if (typeof this.context.model === 'object') {
			// if it's set, but it's "null" that means we want that "latest" version because it's been removed for a "renewal" app with copied data
			if (this.context.model.hasOwnProperty('version')) {
				this.version = this.context.model.version
					? this.context.model.version
					: this.version
			} else if(this.$page.props.application.parent_type !== 'renewal') {
				// the "version" key may not exist for ancient applications
				// so if we're renewing, we can just leave it alone and use the latest version
				this.version = '0'
			}

			this.sport_activity = this.context.model.sport_activity
			this.sport_type = this.context.model.sport_type
			this.sport_details = this.context.model.sport_details
			this.sport_level = this.context.model.sport_level
			this.sport_days = this.context.model.sport_days
			this.participants_per_day = this.context.model.participants_per_day

			this.sport_participants_9 = this.context.model.sport_participants_9
			this.sport_participants_12 = this.context.model.sport_participants_12
			this.sport_participants_13_15 = this.context.model.sport_participants_13_15
			this.sport_participants_16_18 = this.context.model.sport_participants_16_18
			this.sport_participants_19 = this.context.model.sport_participants_19

			this.sport_participants_10 = this.context.model.sport_participants_10
			this.sport_participants_13_16 = this.context.model.sport_participants_13_16
			this.sport_participants_17_19 = this.context.model.sport_participants_17_19
			this.sport_participants_21 = this.context.model.sport_participants_21
			this.sport_participants_22 = this.context.model.sport_participants_22

			this.sport_gross_receipts = this.context.model.sport_gross_receipts
			this.sport_number_of_teams = this.context.model.sport_number_of_teams

			this.tournament_date = this.context.model.tournament_date
			this.concussion_management_policy = this.context.model.concussion_management_policy
			this.concussion_play_removal = this.context.model.concussion_play_removal
			this.concussion_medical_check = this.context.model.concussion_medical_check
			this.concussion_policy_distribution = this.context.model.concussion_policy_distribution
			this.concussion_recognition = this.context.model.concussion_recognition
			this.subcontractors_liability_coverage = this.context.model.subcontractors_liability_coverage
			this.guests_carry_valid_liability = this.context.model.guests_carry_valid_liability
			this.tournament_address = this.context.model.tournament_address

			this.sport_teams_10 = this.context.model.sport_teams_10
			this.sport_teams_12 = this.context.model.sport_teams_12
			this.sport_teams_13_16 = this.context.model.sport_teams_13_16
			this.sport_teams_17_19 = this.context.model.sport_teams_17_19
			this.sport_teams_21 = this.context.model.sport_teams_21
			this.sport_teams_22 = this.context.model.sport_teams_22
		}

		if (this.exists(this.context.attributes.facade)) {
			this.label = this.context.attributes.facade
		}
	}
}
</script>
